import React from 'react';
import {
  Chart,
  CategoryScale,
  PointElement,
  LineElement,
  Colors,
  LinearScale,
  Tooltip,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import 'chartjs-adapter-moment';

Chart.register(CategoryScale, PointElement, LineElement, Colors, LinearScale, Tooltip);

const SmallChart = ({ datasets = [], width = '60px', height = '40px', onTooltip }) => {
  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        mode: 'nearest',
        enabled: false,
        external: (context) => {
          if (!context?.replay) {
            let text = context?.tooltip?.dataPoints[0].raw.tooltip;
            onTooltip(text);
          }
        },
      },
    },
    scales: {
      x: {
        type: 'linear',
        grid: {
          display: false,
        },
        display: false,
        max: datasets[0].data.length - 0.7,
      },
      y: {
        type: 'linear',
        beginAtZero: false,
        grid: {
          display: false,
        },
        display: false,
      },
    },
  };

  const data = {
    datasets: datasets.map((d) => {
      return {
        label: d.label,
        data: d.data,
        backgroundColor: d.data.map(({ color }) => color),
        borderColor: d.data.map(({ color }) => color),
      };
    }),
  };

  return (
    <div className="chart" style={{ width, height }}>
      <Line data={data} options={options} />
    </div>
  );
};

export default SmallChart;
